const app = {
    state: {
        navShow: true,//是否显示侧边栏
        isMobile: false,//是否是移动设备
    },
    mutations: {
        SET_NAVSHOW(state, val) {
            state.navShow = val
        },
        SET_ISMOBILE(state, val) {
            state.isMobile = val
        },
    },
    actions: {
        toogleNavShow({ commit }, val) {
            commit('SET_NAVSHOW', val)
        },
        isMobile({ commit }, val) {
            commit('SET_ISMOBILE', val)
        }
    }
}

export default app